import {useMutation} from '@apollo/client';
import {Form, Input} from 'antd';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {REVERSE_REWARD} from 'graphql/mutations/rewardScheme';
import {toast} from 'react-toastify';
import styles from './reverseReward.module.scss';

export const ReverseReward = ({id, form, refetch, onClose}) => {
  const [reverseReward, {loading}] = useMutation(REVERSE_REWARD, {
    onError: error => toast.error(error.message),
  });

  const handleFinish = values => {
    reverseReward({
      variables: {
        rewardId: id,
        reason: values.reason,
      },
    })
      .then(({data: {adminReverseReward}}) => {
        if (
          adminReverseReward.__typename === 'Error' ||
          adminReverseReward.statusCode === 400
        ) {
          toast.error(adminReverseReward.message);
        } else {
          toast.success(adminReverseReward.message);
          form.resetFields();
          refetch();
          onClose();
        }
      })
      .catch(error => toast.error(error.message));
  };

  return (
    <div className={styles.modal}>
      <h1>Reverse Reward</h1>
      <p className={styles.warning}>This action cannot be undone</p>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className={styles.form}>
        <Form.Item
          className={styles.field}
          rules={[{required: true, message: 'This field is required'}]}
          name="reason"
          label="Reason">
          <Input.TextArea
            rows={4}
            placeholder="Please provide a reason for reversing this reward"
          />
        </Form.Item>
        <div className={styles.submitButton}>
          <SubmitButton disabled={loading} label="Reverse" />
        </div>
      </Form>
    </div>
  );
};
